import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import windowSize from 'react-window-size';
import { Button, Navbar, Nav, Container, Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { toggleNavigationShown, toggleNavigationMenuOpened, toggleNavigationExpanded } from '../../AppActions';

// Import Style
import './Navigation.scss';

import logo from '../../../../assets/img/nave-logo-white.svg';
import _ from 'lodash';

class Navigation extends Component {
  static defaultProps = {
    showLinks: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  handleHover(){
    if (this.state.isLocked) return
    this.setState(prevState => ({
      isLocked: prevState.isHovered,
      isHovered: !prevState.isHovered
    }), () => setTimeout(() => this.setState({ isLocked: false }), 100));
  }



  isActive(path, search) {
    return this.props && this.props.location && this.props.location.search === search
    && (this.props.location.pathname === path || this.props.location.pathname === path + '/');
  }

  componentDidMount() {
    const navigation = window && window.localStorage && window.localStorage.getItem('navigation');
    if (navigation) {
      let value;
      try {
        value = JSON.parse(navigation);
      } catch (err) {}
      if (value) {
        this.props.toggleNavigationShown(value.navigationShown || false);
        this.props.toggleNavigationMenuOpened(value.navigationMenuOpened || false);
        this.props.toggleNavigationExpanded(value.navigationExpanded || ['flow-metrics', 'executive']);
      }
    } else {
      this.props.toggleNavigationShown(false);
      this.props.toggleNavigationMenuOpened(false);
      this.props.toggleNavigationExpanded(['flow-metrics', 'executive']);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      window && window.localStorage && (
        prevProps.navigationExpanded !== this.props.navigationExpanded || 
        prevProps.navigationShown !== this.props.navigationShown ||
        prevProps.navigationMenuOpened !== this.props.navigationMenuOpened
      )
    ) {
      if (window && window.localStorage) {
        window.localStorage.setItem('navigation', JSON.stringify({
          navigationShown: this.props.navigationShown,
          navigationExpanded: this.props.navigationExpanded,
          navigationMenuOpened: this.props.navigationMenuOpened
        }));
      }
    }
  }

  render() {
    const {
      showLinks,
      dashboard,
      user,
      toggleNavigationShown,
      navigationShown,
      toggleNavigationMenuOpened,
      navigationMenuOpened,
      toggleNavigationExpanded,
      navigationExpanded
    } = this.props;
    const { isHovered } = this.state;
    const dashboardId = dashboard && dashboard._id ? dashboard._id : user.config.selectedDashboard;
    const links = [
      <LinkContainer key="1" to={`/dashboard/${dashboardId}/process`}>
        <Nav.Link eventKey={1}>
          <span className='images process_improvement'></span>
          <span>Process Improvement</span>
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="process-improvement" className='tooltip_dark max-width-200 text-align-left'>Process Improvement</Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
          {/*<FormattedMessage id="process_improvement" />*/}
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="2" className="disabled" to={`/dashboard/${dashboardId}/?planning-forecasting=true`}>
        <Nav.Link eventKey={2}>
          <span className='images planning_forecasting'></span>
          <span>Planning & Forecasting</span>
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="planning-forecasting" className='tooltip_dark max-width-200 text-align-left'>Planning & Forecasting</Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
          {/*<FormattedMessage id="planning_forecasting" />*/}
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="3" className="disabled" to={`/dashboard/${dashboardId}/?prioritization-and-dependency-management=true`}>
        <Nav.Link eventKey={3}>
          <span className='images prioritization'></span>
          <span>Prioritization & Dependency Management</span>
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="prioritization-dependency-management" className='tooltip_dark max-width-200 text-align-left'>Prioritization & Dependency Management</Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
          {/*<FormattedMessage id="prioritization" />*/}
        </Nav.Link>
      </LinkContainer>,
    ];
    const linksExecutive = [
      <Nav.Link as={Link} eventKey={4} to="/report">        
        <span className='images executive-head'></span>
        <FormattedMessage id="exec_rep" />
        <OverlayTrigger placement="right" 
          overlay={<Tooltip id="executive-dashboard" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="exec_rep" /></Tooltip>}>
          <span className="tooltip"></span>
        </OverlayTrigger>
      </Nav.Link>,
      <LinkContainer key="5" to="/portfolios">
        <Nav.Link eventKey={6}>          
          <span className='images exec_rep'></span>
          <FormattedMessage id="comp_rep" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="executive-report" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="comp_rep" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>
    ]
    const linksDashboard = [
      <LinkContainer key="1" to={`/dashboard/${dashboardId}/process`}>
      <Nav.Link eventKey={1}>
        <span className='images process_improvement'></span>
        <span>Process Improvement</span>
        <OverlayTrigger placement="right" 
          overlay={<Tooltip id="process-improvement" className='tooltip_dark max-width-200 text-align-left'>Process Improvement</Tooltip>}>
          <span className="tooltip"></span>
        </OverlayTrigger>
        {/*<FormattedMessage id="process_improvement" />*/}
      </Nav.Link>
    </LinkContainer>,
      <Nav.Link as={Link} eventKey={7} to={`/dashboard/${dashboardId}`} className={this.isActive(`/dashboard/${dashboardId}`, '') ? 'active' : ''} >
        <span className='images flow-metric-head'></span>
        <span>Flow Metrics & Analytics</span>
        <OverlayTrigger placement="right" 
          overlay={<Tooltip id="home" className='tooltip_dark max-width-200 text-align-left'>Flow Metrics & Analytics</Tooltip>}>
          <span className="tooltip"></span>
        </OverlayTrigger>
      </Nav.Link>,
      <LinkContainer key="8" to={`/dashboard/${dashboardId}/cfd`}>
        <Nav.Link eventKey={8}>
          <span className='images cfd'></span>
          <FormattedMessage id="cfd" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="cumulative-flow-diagram" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="cfd" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="9" to={`/dashboard/${dashboardId}/ctsp`}>
        <Nav.Link eventKey={9}>
          <span className='images ctsp'></span>
          <FormattedMessage id="ctsp" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="cycle-time-scatterplot" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="ctsp" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="10" to={`/dashboard/${dashboardId}/ctb`}>
        <Nav.Link eventKey={10}>
          <span className='images ctb'></span>
          <FormattedMessage id="ctb" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="cycle-time-breakdown" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="ctb" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="11" to={`/dashboard/${dashboardId}/cth`}>
        <Nav.Link eventKey={11}>
          <span className='images cth'></span>
          <FormattedMessage id="cth" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="cycle-time-histogram" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="cth" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="12" to={`/dashboard/${dashboardId}/cta`}>
        <Nav.Link eventKey={12}>
          <span className='images cta'></span>
          <FormattedMessage id="cta" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="aging-chart" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="cta" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="13" to={`/dashboard/${dashboardId}/trc`}>
        <Nav.Link eventKey={13}>
          <span className='images trc'></span>
          <FormattedMessage id="throughput" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="throughput-run" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="throughput" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="14" to={`/dashboard/${dashboardId}/th`}>
        <Nav.Link eventKey={14}>
          <span className='images th'></span>
          <FormattedMessage id="throughputHistogram" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="throughput-histogram" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="throughputHistogram" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="15" to={`/dashboard/${dashboardId}/fe`}>
        <Nav.Link eventKey={15}>
          <span className='images fe'></span>
          <FormattedMessage id="flowEfficiency" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="flow-efficiency" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="flowEfficiency" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="16" to={`/dashboard/${dashboardId}/ddp`}>
        <Nav.Link eventKey={16}>
          <span className='images ddp'></span>
          <FormattedMessage id="dueDatePerf" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="due-date-performance" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="dueDatePerf" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="17" to={`/dashboard/${dashboardId}/montecarlodates`}>
        <Nav.Link eventKey={17}>
          <span className='images mc1'></span>
          <FormattedMessage id="monteCarloDate" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="monte-carlo-delivery-date" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="monteCarloDate" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
      <LinkContainer key="18" to={`/dashboard/${dashboardId}/montecarlotasks`}>
        <Nav.Link eventKey={18}>
          <span className='images mc2'></span>
          <FormattedMessage id="monteCarloTasks" />
          <OverlayTrigger placement="right" 
            overlay={<Tooltip id="monte-carlo-number-tasks" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="monteCarloTasks" /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        </Nav.Link>
      </LinkContainer>,
       <LinkContainer key="19" to={`/dashboard/${dashboardId}/forecasts`}>
       <Nav.Link eventKey={19}>
         <span className='images continues-forecasting'></span>
         <FormattedMessage id="continuesForecasting" />
         <OverlayTrigger placement="right" 
           overlay={<Tooltip id="continues-forecasting" className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id="continuesForecasting" /></Tooltip>}>
           <span className="tooltip"></span>
         </OverlayTrigger>
       </Nav.Link>
     </LinkContainer>
    ];

    return (
      <div className={`navigation ${!navigationMenuOpened ? 'nav-main-close' : 'nav-main-open'} ${!showLinks && 'no-show-link'}`} >
        <div className="navigation-inner">
          <div className='header_logo'>
            { this.props.outside ?(<img src={logo} alt="" />):
            this.props.windowWidth > 992 ? (
              <Link className="logo" to={`${dashboard && dashboard._id ? `/dashboard/${dashboardId}/process` : '/'}`}>
                <img src={logo} alt="" />
              </Link>
            ) : (
              <Button id="hamburger-button" className='btn-hamburger' onClick={() => toggleNavigationShown(!navigationShown)}>
                <span></span>
                <span></span>
                <span></span>
              </Button>
            )}
          </div>
          <Navbar>
            <Container>
            {showLinks &&
              <Nav className='menu'>
                {/* {links} */}
                <Accordion activeKey={navigationExpanded} onSelect={toggleNavigationExpanded} alwaysOpen>
                  <Accordion.Item eventKey="flow-metrics" className='links-wrap'>
                    <Accordion.Header className="links-wrap-header nav-link">
                      <span className='images flow-metric'></span>
                      <span>Team Dashboards</span>
                      <OverlayTrigger placement="right" 
                        overlay={<Tooltip id="team-dashboards" className='tooltip_dark max-width-200 text-align-left'>Team Dashboards</Tooltip>}>
                        <span className="tooltip"></span>
                      </OverlayTrigger>
                    </Accordion.Header>
                    <Accordion.Body>
                      {linksDashboard}
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="executive" className='links-wrap' >
                    <Accordion.Header className="links-wrap-header nav-link">                      
                      <span className='images portfolios_head dark'></span>
                      <span>Portfolio Dashboards</span>
                      <OverlayTrigger placement="right" 
                        overlay={<Tooltip id="executive-view" className='tooltip_dark max-width-200 text-align-left'>Portfolio Dashboards</Tooltip>}>
                        <span className="tooltip"></span>
                      </OverlayTrigger>
                    </Accordion.Header>
                    <Accordion.Body>
                      {linksExecutive}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Nav>
            }
            </Container>
          </Navbar>
        </div>
        <div className="btn-open-menu" >
          <button onClick={() => toggleNavigationMenuOpened(!navigationMenuOpened)}></button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleNavigationShown: show => dispatch(toggleNavigationShown(show)),
    toggleNavigationExpanded: expanded => dispatch(toggleNavigationExpanded(expanded)),
    toggleNavigationMenuOpened: opened => dispatch(toggleNavigationMenuOpened(opened)),
  };
};

function mapStateToProps(state) {
  return {
    app: state.app.app,
    navigationShown: state.app.navigationShown,
    navigationExpanded: state.app.navigationExpanded,
    navigationMenuOpened: state.app.navigationMenuOpened,
    dashboard: state.dashboards.selected,    
    outside: state.app.outside,
    user: state.auth.user,
  };
}

export default windowSize(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps, null, {
      pure: false
    })(Navigation)
  )
);
